/**
 * CSS class names for form inputs
 */
export const INPUT_CLASSES = {
    BASE: 'input-float__input',
    NOT_EMPTY: 'input-float__input_not-empty',
    FOCUSED: 'input-float__input_focused',
    CHECKED: 'input-float__input_checked'
};
